import { TextFieldWrapper } from "../style/ConditionSelector.styled";

export default function TextFieldView () {
    return (
        <TextFieldWrapper>
            <div>* 선택된 상품의 모든 옵션이 조회됩니다.</div>
            <div>* 옵션을 선택해 상품의 옵션별 성과를 확인할 수 있습니다.</div>
        </TextFieldWrapper>
    )
}